import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const overrides: NonNullable<
  Components<CssVarsTheme>['MuiAppBar']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => ({
    ...(ownerState.color === 'inherit' && {
      boxShadow: theme.shadows[2],
    }),
  }),
};

const styleOverrides: Pick<Components<CssVarsTheme>['MuiAppBar'], never> = {
  styleOverrides: overrides,
};

export default styleOverrides;
